export default defineNuxtPlugin(() => {
  const { show, hide, state } = useTermsModal()

  return {
    provide: {
      termsModal: {
        state,
        show,
        hide,
      },
    },
  }
})
